export default "__VITE_ASSET__CB4ZDd0F__"